// Copyright (c) Docugami, Inc. All rights reserved.

import { DocSourceId } from "components/myContentExplorer/ExplorerTypes";
import { ActionTileId } from "hooks/ActionTileItems";
import { WorkPathType } from "networking/WorkPathApi";
import { ReportViewMode } from "hooks/navigationService";
import { DocSetIndicatorSteps } from "components/myContentExplorer/DocSetStatusIndicator";

export enum AutomationId {
    // doc explorer
    DocExplorerAddDocs = 'DocExplorerAddDocs',
    DocExplorerAddDocsFinish = 'DocExplorerAddDocsFinish',
    DocExplorerAddDocsClose = 'DocExplorerAddDocsClose',
    DocExplorerAddDocsAddMore = 'DocExplorerAddDocsAddMore',
    DocExplorerAddDocsAutoAssigning = 'DocExplorerAddDocsAutoAssigning',
    DocExplorerSourceOptions = 'DocExplorerSourceOptions',
    DocExplorerSourceBox = 'DocExplorerSourceBox',
    DocExplorerSourceLocalDocs = 'DocExplorerSourceLocalDocs',
    DocExplorerSourceDropbox = 'DocExplorerSourceDropbox',
    DocExplorerSourceOneDrive = 'DocExplorerSourceOneDrive',
    DocExplorerSourceSharePoint = 'DocExplorerSourceSharePoint',
    DocExplorerUnassignedDocs = 'DocExplorerUnassignedDocs',
    DocExplorerErrorDocs = 'DocExplorerErrorDocs',
    DocExplorerBrowseSamples = 'DocExplorerBrowseSamples',
    DocExplorerInstallSampleButton = 'DocExplorerInstallSampleButton',

    // docset
    DocSetId = "DocSetId",
    DocSetStatus = "DocSetStatus",
    DocSetProgress = "DocSetProgress",


    // home page elements
    HomeActionsPanel = 'HomeActionsPanel',
    HomeMyWorkPanel = 'HomeMyWorkPanel',

    // action tiles
    ActionTileExpiredInfo = 'ActionTileExpiredInfo',
    ActionTileAddDocs = 'ActionTileAddDocs',
    ActionTileTabularReport = 'ActionTileTabularReport',
    ActionTileAbstract = 'ActionTileAbstract',
    ActionTileExcelExport = 'ActionTileExcelExport',
    ActionTileAutomationAnywhereDocumentAssembly = 'ActionTileAutomationAnywhereDocumentAssembly',
    ActionTileAutomationAnywhereWorkFlow = 'ActionTileAutomationAnywhereWorkFlow',
    ActionTileUiPathWorkFlow = 'ActionTileUiPathWorkFlow',
    ActionTileUiPathDocumentAssembly = 'ActionTileUiPathDocumentAssembly',
    ActionTileDiligenceReport = 'ActionTileDiligenceReport',
    ActionTileExpirationWarning = 'ActionTileExpirationWarning',
    ActionTilePageLimitWarning = 'ActionTilePageLimitWarning',
    ActionTileUsersLimitWarning = 'ActionTileUsersLimitWarning',

    // global nav
    NavItemHome = 'NavItemHome',
    NavItemSettings = 'NavItemSettings',
    NavItemHidden = 'NavItemHidden',
    NavItemMyContent = 'NavItemMyContent',
    NavItemProjects = 'NavItemProjects',
    NavItemFeedback = 'NavItemFeedback',
    NavItemAccount = 'NavItemAccount',
    NavItemHelp = 'NavItemHelp',
    NavItemDiscovery = 'NavItemDiscovery',
    NavItemProfile = 'NavItemProfile',
    NavItemNotifications = 'NavItemNotifications',

    // work paths ux
    RecommendedDocsNone = 'RecommendedDocsNone',
    SDVChunkToolbar = 'SDVChunkToolbar',
    WorkPathChooseDocSetAndNameNextButton = 'WorkPathChooseDocSetAndNameNextButton',
    WorkPathViewSwitcher = 'WorkPathViewSwitcher',
    WorkPathReviewSetProgress = 'WorkPathReviewSetProgress',
    WorkPathConnectorMenuItem = 'WorkPathConnectorMenuItem',
    WorkPathActionCommands = 'WorkPathActionCommands',
    ReportActionsMenuButton = 'ReportActionsMenuButton',
    WorkPathNextStepsMenuButton = 'WorkPathNextStepsMenuButton',
    AbstractDocumentNavigation = 'AbstractDocumentNavigation',
    ReportReviewNextDocButton = 'ReportReviewNextDocButton',
    ReportReviewPublishButton = 'ReportReviewPublishButton',
    RemoveEntryConfirmationButton = 'RemoveEntryConfirmationButton',
    // These are for the view specific info button
    WorkPathTableInfoButton = 'WorkPathTableInfoButton',
    WorkPathDocumentInfoButton = 'WorkPathDocumentInfoButton',
    WorkPathChatInfoButton = 'WorkPathChatInfoButton',
    WorkPathAbstractInfoButton = 'WorkPathAbstractInfoButton',
    // This is for a unconfirmed confirmation button
    WorkPathUnconfirmedItemButton = 'WorkPathUnconfirmedItemButton',
    // This is for a unconfirmed confirmation button
    WorkPathConfirmedItemButton = 'WorkPathConfirmedItemButton',
    // This is for a show more like this button
    WorkPathShowMoreLikeThisButton = 'WorkPathShowMoreLikeThisButton',
    // This is for a hide more like this button
    WorkPathHideMoreLikeThisButton = 'WorkPathHideMoreLikeThisButton',
    // This is for table value cells
    WorkPathDocumentTableChunk = 'WorkPathDocumentTableChunk',


    // work path types
    WorkPathTypeTabularReport = 'WorkPathTypeTabularReport',
    WorkPathTypeAbstract = 'WorkPathTypeAbstract',
    WorkPathTypeExcelExport = 'WorkPathTypeExcelExport',
    WorkPathTypeAutomationAnywhereDocumentAssembly = 'WorkPathTypeAutomationAnywhereDocumentAssembly',
    WorkPathTypeAutomationAnywhereWorkFlow = 'WorkPathTypeAutomationAnywhereWorkFlow',
    WorkPathTypeUiPathWorkFlow = 'WorkPathTypeUiPathWorkFlow',
    WorkPathTypeUiPathDocumentAssembly = 'WorkPathTypeUiPathDocumentAssembly',
    WorkPathTypeDiligenceReport = 'WorkPathTypeDiligenceReport',
    WorkPathTypeChat = 'WorkPathTypeChat',
    // Work path grid elements
    // This is the overall overflow menu for the grid view in cell(0,0)
    WorkPathGridOverallMenu = 'WorkPathGridOverallMenu',
    // This is for a document row
    WorkPathGridDocumentRow = 'WorkPathGridDocumentRow',
    // This is for a document title cell
    WorkPathGridDocumentTitleCell = 'WorkPathGridDocumentTitleCell',
    // This is for the entry title header cell
    WorkPathGridDocumentEntryTitleCell = 'WorkPathGridDocumentEntryTitleCell',
    // This is for the entry value cell
    WorkPathGridDocumentEntryValueCell = 'WorkPathGridDocumentEntryValueCell',

    // Work path document elements
    // This is for the selected item panel in the report work pane
    WorkPathDocumentSelectedItemPanel = 'WorkPathDocumentSelectedItemPanel',
    // This is for the unselected item cardlet in the report work pane
    WorkPathDocumentItemCardlet = 'WorkPathDocumentItemCardlet',
    // This is for the free select panel in the report work pane
    WorkPathDocumentFreeSelectEditorPanel = 'WorkPathDocumentFreeSelectEditorPanel',

    // subscriptions
    SubscriptionTypeIsTrial = 'SubscriptionTypeIsTrial'
}

export interface AutomationProps {
    automationId?: AutomationId;
}

// This is for the info button in the work path header
export function getAutomationIdForInfoButton(view: ReportViewMode) {
    switch (view) {
        case ReportViewMode.Table:
            return AutomationId.WorkPathTableInfoButton;
        case ReportViewMode.Document:
            return AutomationId.WorkPathDocumentInfoButton;
        case ReportViewMode.Chat:
            return AutomationId.WorkPathChatInfoButton;
        case ReportViewMode.Abstract:
            return AutomationId.WorkPathAbstractInfoButton;
        default:
            throw new Error("Unknown view mode without corresponding automation ID.");
    }
}

export function getAutomationIdForDocSourceId(docSourceId: DocSourceId): AutomationId {
    switch (docSourceId) {
        case DocSourceId.Box:
            return AutomationId.DocExplorerSourceBox;
        case DocSourceId.Local:
            return AutomationId.DocExplorerSourceLocalDocs;
        case DocSourceId.Dropbox:
            return AutomationId.DocExplorerSourceDropbox;
        case DocSourceId.OneDrive:
            return AutomationId.DocExplorerSourceOneDrive;
        case DocSourceId.SharePoint:
            return AutomationId.DocExplorerSourceSharePoint;
        default:
            throw new Error("Unknown doc source type without corresponding automation ID.");
    }
}

export function getAutomationIdForWorkPathType(workPathType: WorkPathType): AutomationId {
    switch (workPathType) {
        case WorkPathType.TabularReport:
            return AutomationId.WorkPathTypeTabularReport;
        case WorkPathType.Abstract:
            return AutomationId.WorkPathTypeAbstract;
        case WorkPathType.ExcelExport:
            return AutomationId.WorkPathTypeExcelExport;
        case WorkPathType.DiligenceReport:
            return AutomationId.WorkPathTypeDiligenceReport;
        case WorkPathType.AutomationAnywhereDocumentAssembly:
            return AutomationId.WorkPathTypeAutomationAnywhereDocumentAssembly;
        case WorkPathType.AutomationAnywhereWorkFlow:
            return AutomationId.WorkPathTypeAutomationAnywhereWorkFlow;
        case WorkPathType.UiPathWorkFlow:
            return AutomationId.WorkPathTypeUiPathWorkFlow;
        case WorkPathType.UiPathDocumentAssembly:
            return AutomationId.WorkPathTypeUiPathDocumentAssembly;
        default:
            throw new Error("Unknown workpath type without corresponding automation ID.");
    }
}

export function getAutomationIdForActionTileId(actionTileId: ActionTileId): AutomationId {
    switch (actionTileId) {
        case ActionTileId.ExpiredInfo:
            return AutomationId.ActionTileExpiredInfo;
        case ActionTileId.AddDocs:
            return AutomationId.ActionTileAddDocs;
        case ActionTileId.TabularReport:
            return AutomationId.ActionTileTabularReport;
        case ActionTileId.Abstract:
            return AutomationId.ActionTileAbstract;
        case ActionTileId.ExcelExport:
            return AutomationId.ActionTileExcelExport;
        case ActionTileId.AutomationAnywhereDocumentAssembly:
            return AutomationId.ActionTileAutomationAnywhereDocumentAssembly;
        case ActionTileId.AutomationAnywhereWorkFlow:
            return AutomationId.ActionTileAutomationAnywhereWorkFlow;
        case ActionTileId.UiPathWorkFlow:
            return AutomationId.ActionTileUiPathWorkFlow;
        case ActionTileId.UiPathDocumentAssembly:
            return AutomationId.ActionTileUiPathDocumentAssembly;
        case ActionTileId.DiligenceReport:
            return AutomationId.ActionTileDiligenceReport;
        case ActionTileId.ExpirationWarning:
            return AutomationId.ActionTileExpirationWarning;
        case ActionTileId.PageLimitWarning:
            return AutomationId.ActionTilePageLimitWarning;
        case ActionTileId.UsersLimitWarning:
            return AutomationId.ActionTileUsersLimitWarning;
        default:
            throw new Error("Unknown action tile ID without corresponding automation ID.");
    }
}

export function getAutomationIdForWorkPathConnector(workPathType?: WorkPathType) {
    if (!workPathType) {
        return;
    }

    return `${AutomationId.WorkPathConnectorMenuItem}_${getAutomationIdForWorkPathType(workPathType)}`;
}

export function getAutomationIdForReportPageAnchor(workPathType: WorkPathType | undefined, isPublished?: boolean) {
    if (workPathType !== WorkPathType.DiligenceReport) {
        return;
    }

    return !!isPublished ? `Published_${getAutomationIdForWorkPathType(workPathType)}` : '';
}

export function getAutomationIdForDocSetId(docSetId: string): string {
    return `${AutomationId.DocSetId}_${docSetId}`
}

export function getAutomationIdForDocsetStatus(docSetStatus: string): string {
    return `${AutomationId.DocSetStatus}_${docSetStatus}`;
}

export function getAutomationIdForDocsetProgressIndicator(step: DocSetIndicatorSteps, complete?: boolean): string {
    const id = `${AutomationId.DocSetProgress}_${step}`;
    return complete !== undefined ? addAutomationIdCompletePart(id, complete) : id;
}

export function addAutomationIdCompletePart(id: string, complete: boolean) {
    return id + `_${complete ? 'Complete' : 'Incomplete'}`;
}
